var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center flex-col py-3 mt-8"},[_c('LoadingIcon',{staticClass:"w-10 h-10",attrs:{"icon":"oval"}}),_c('p',{staticClass:"text-gray-500 mt-3"},[_vm._v(_vm._s(_vm.$t('table.loading')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }